import { sendRequest } from "../base.service";

export const getAboutList = () => {
  return sendRequest("/about");
};
export const getHomeAbout = () => {
  return sendRequest("/home/about");
};
export const getAttachmentsList = () => {
  return sendRequest("/home/attachment");
};
export const getVSATAboutList = () => {
  return sendRequest("/about/vsat");
};
export const getRetiredAboutList = () => {
  return sendRequest("/about/retired");
};
export const getCounterList = () => {
  return sendRequest("/vsat/counter");
};
export const getEventsList = () => {
  return sendRequest("/event");
};
export const getEventNewsList = (id) => {
  return sendRequest("/event/news/" + id);
};
export const getSingleEvent = (id) => {
  return sendRequest("/event/list/" + id);
};
export const getSingleLanding = (id) => {
  return sendRequest("/landing/" + id);
};
export const getEventDetails = (id) => {
  return sendRequest("/event/details/" + id);
};
export const getEnglishEventsList = () => {
  return sendRequest("/en/event/list");
};
export const getEnglishAboutList = () => {
  return sendRequest("/about/en");
};
export const getSubSystemList = () => {
  return sendRequest("/partner/sub");
};
